import typogr from 'typogr'

export const widont = (html) => {
  return typogr(html).widont()
}
